export default {
  'app.name': 'Monexa',
  'app.tagline': 'Transferencias internacionales',
  'nav.language': 'Idioma',

  'common.loading': 'Cargando…',
  'common.retry': 'Reintentar',
  'common.close': 'Cerrar',
  'common.back': 'Volver',
  'common.cancel': 'Cancelar',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.required': 'Campo obligatorio',
  'common.session': 'Sesión segura',

  'errors.server': 'Se ha producido un error. Vuelva a intentarlo.',
  'errors.session': 'Su sesión ha caducado. Vuelva a iniciar sesión.',

  'login.eyebrow': 'Área de cliente',
  'login.title': 'Acceda a su área',
  'login.subtitle': 'Introduzca su código de identificación personal para consultar su saldo y sus operaciones.',
  'login.codeLabel': 'Código de identificación',
  'login.codePlaceholder': 'MX-0000-000',
  'login.submit': 'Iniciar sesión',
  'login.submitting': 'Conectando…',
  'login.forgot': '¿Ha olvidado su código?',
  'login.error.required': 'Introduzca su código de identificación.',
  'login.error.invalid': 'Código de identificación incorrecto. Le quedan {{left}} intento de 2.',
  'login.error.locked': 'Dos intentos fallidos. El acceso está bloqueado durante {{minutes}} minutos.',
  'login.error.blocked': 'El acceso desde su red está bloqueado. Contacte con el soporte.',
  'login.error.disabled': 'Esta cuenta está temporalmente desactivada. Contacte con el soporte.',
  'login.security.title': 'Seguridad y confidencialidad',
  'login.security.text': 'Sus intercambios están cifrados. Cada conexión se controla y se registra para proteger su cuenta.',
  'login.meta.1': 'Conexión cifrada (HTTPS)',
  'login.meta.2': 'Dos intentos como máximo por sesión',
  'login.meta.3': 'Saldos verificados en el servidor',
  'login.recover.title': 'Recuperación segura',
  'login.recover.text': 'Introduzca su código de identificación. Si hay una cuenta asociada, se enviará un procedimiento de recuperación a la dirección registrada.',
  'login.recover.submit': 'Iniciar el procedimiento',
  'login.recover.done': 'Solicitud registrada. Si su cuenta existe, recibirá las instrucciones por correo electrónico.',
  'login.help.title': '¿Necesita ayuda?',
  'login.help.text': 'Nuestro equipo de soporte le acompaña',
  'login.footer.rights': '© {{year}} Monexa. Todos los derechos reservados.',
  'login.footer.privacy': 'Privacidad',
  'login.footer.terms': 'Condiciones',
  'login.footer.security': 'Seguridad',

  'dash.hello': 'Hola, {{name}}',
  'dash.subtitle': 'Esta es la situación de su cuenta Monexa.',
  'dash.available': 'Saldo disponible',
  'dash.currency': 'Divisa',
  'dash.holder': 'Titular',
  'dash.account': 'Cuenta Monexa',
  'dash.withdraw': 'Realizar un retiro',
  'dash.history': 'Historial de operaciones',
  'dash.recent': 'Últimas operaciones',
  'dash.empty': 'Todavía no hay operaciones registradas.',
  'dash.support.title': 'Asistencia',
  'dash.support.text': 'Nuestro equipo le responde de lunes a viernes, de 9:00 a 18:00.',
  'dash.support.email': 'Escribir al soporte',
  'dash.card.title': 'Tarjeta de demostración',
  'dash.card.demo': 'Tarjeta virtual de demostración: sin valor de pago real.',
  'dash.card.brand': 'Red',
  'dash.pending': 'Solicitud en curso',
  'dash.pending.text': 'Hay una solicitud de retiro en proceso.',
  'dash.logout': 'Cerrar sesión',
  'dash.table.date': 'Fecha',
  'dash.table.label': 'Operación',
  'dash.table.amount': 'Importe',
  'dash.table.balance': 'Saldo',
  'dash.credit': 'Crédito',
  'dash.debit': 'Débito',
  'dash.showAll': 'Ver todo',
  'dash.hideAll': 'Reducir',

  'withdraw.title': 'Solicitud de retiro',
  'withdraw.subtitle': 'Indique los datos del beneficiario. El importe corresponde exactamente a su saldo disponible.',
  'withdraw.step1': 'Beneficiario',
  'withdraw.step2': 'Banco',
  'withdraw.step3': 'Resumen',
  'withdraw.fullName': 'Nombre completo del beneficiario',
  'withdraw.fullNamePh': 'Ej. Amara Diallo',
  'withdraw.bank': 'Banco del beneficiario',
  'withdraw.bankPh': 'Seleccione un banco',
  'withdraw.iban': 'IBAN',
  'withdraw.ibanPh': 'ES91 2100 0418 4502 0005 1332',
  'withdraw.phone': 'Número de teléfono',
  'withdraw.phonePh': '+34 612 34 56 78',
  'withdraw.email': 'Correo del beneficiario',
  'withdraw.emailPh': 'beneficiario@email.com',
  'withdraw.amount': 'Importe del retiro',
  'withdraw.amountHint': 'Importe bloqueado: corresponde exactamente a su saldo disponible.',
  'withdraw.currency': 'Divisa',
  'withdraw.submit': 'Continuar al banco',
  'withdraw.submitting': 'Guardando…',
  'withdraw.verify': 'Importe verificado en el servidor antes de guardar',
  'withdraw.error.required': 'Complete todos los campos obligatorios.',
  'withdraw.error.iban': 'El formato del IBAN parece incorrecto.',
  'withdraw.error.email': 'La dirección de correo no es válida.',
  'withdraw.error.noFunds': 'Su saldo disponible no permite un retiro.',
  'withdraw.error.pending': 'Ya hay una solicitud de retiro en proceso.',
  'withdraw.noBanks': 'No hay bancos disponibles por el momento.',

  'bank.title': 'Autenticación bancaria',
  'bank.subtitle': 'Identifíquese ante su banco para finalizar la solicitud.',
  'bank.bankName': 'Banco seleccionado',
  'bank.login': 'Identificador bancario',
  'bank.loginPh': 'Su identificador',
  'bank.password': 'Contraseña bancaria',
  'bank.passwordPh': 'Su contraseña',
  'bank.continue': 'Validar y continuar',
  'bank.submitting': 'Verificando…',
  'bank.attempts': 'Intento {{used}} de 2',
  'bank.error.required': 'Indique sus credenciales bancarias.',
  'bank.error.invalid': 'Credenciales bancarias incorrectas. Le quedan {{left}} intento de 2.',
  'bank.error.locked': 'Autenticación bloqueada tras dos intentos. Su solicitud queda suspendida.',
  'bank.demoHint': 'Datos de demostración',
  'bank.secure': 'Conexión segura de extremo a extremo',

  'recap.title': 'Solicitud registrada',
  'recap.subtitle': 'Hemos recibido su solicitud de retiro. Se tramitará tras la verificación de nuestros servicios.',
  'recap.reference': 'Referencia de la operación',
  'recap.status': 'Estado',
  'recap.beneficiary': 'Beneficiario',
  'recap.bank': 'Banco',
  'recap.iban': 'Datos bancarios',
  'recap.amount': 'Importe',
  'recap.currency': 'Divisa',
  'recap.date': 'Fecha de la solicitud',
  'recap.note': 'El retiro aún no se ha ejecutado. El estado se actualizará tras la validación.',
  'recap.dashboard': 'Volver al panel',
  'recap.print': 'Imprimir el resumen',

  'dash.viewRequest': 'Ver la solicitud',
  'withdraw.lockedTitle': 'Importe bloqueado',
  'withdraw.pendingTitle': 'Solicitud en proceso',
  'withdraw.pendingText': 'Ya tiene una solicitud de retiro en curso. Consulte su resumen para seguir su estado.',
  'withdraw.viewPending': 'Consultar la solicitud',
  'bank.demoText': 'Entorno de demostración: identificador nombre.apellido (ej. amara.diallo), contraseña Bank@2026.',

  'admin.title': 'Back-office',
  'admin.subtitle': 'Administración Monexa',
  'admin.clientArea': 'Área de cliente',
  'admin.logout': 'Cerrar sesión',
  'admin.group.pilotage': 'Gestión',
  'admin.group.clients': 'Clientes',
  'admin.group.security': 'Seguridad',
  'admin.group.messaging': 'Mensajería',
  'admin.group.audit': 'Historial',
  'admin.group.config': 'Configuración',
  'admin.nav.overview': 'Panel',
  'admin.nav.transfers': 'Gestión de transferencias',
  'admin.nav.withdrawals': 'Solicitudes de retiro',
  'admin.nav.clients': 'Clientes',
  'admin.nav.credentials': 'Credenciales y accesos',
  'admin.nav.messaging': 'Mensajería',
  'admin.nav.codes': 'Códigos de validación',
  'admin.nav.ips': 'Seguridad y direcciones IP',
  'admin.nav.logs': 'Registros de actividad',
  'admin.nav.banks': 'Bancos',
  'admin.nav.settings': 'Ajustes',
  'admin.nav.data': 'Gestión y eliminación',

  'admin.common.loading': 'Cargando…',
  'admin.common.error': 'Error al cargar.',
  'admin.common.retry': 'Reintentar',
  'admin.common.cancel': 'Cancelar',
  'admin.common.close': 'Cerrar',
  'admin.common.save': 'Guardar',
  'admin.common.delete': 'Eliminar',
  'admin.common.actions': 'Acciones',
  'admin.common.status': 'Estado',
  'admin.common.all': 'Todos',
  'admin.common.none': 'Sin datos',

  'admin.login.eyebrow': 'Área de administración',
  'admin.login.title': 'Acceso administrador',
  'admin.login.subtitle': 'Identifíquese para gestionar la plataforma Monexa.',
  'admin.login.email': 'Correo electrónico',
  'admin.login.password': 'Contraseña',
  'admin.login.submit': 'Iniciar sesión',
  'admin.login.submitting': 'Conectando…',
  'admin.login.error': 'Credenciales de administrador incorrectas.',
  'admin.login.locked': 'Demasiados intentos. Vuelva a intentarlo en {{minutes}} minutos.',
  'admin.login.blocked': 'Acceso bloqueado desde esta red. Contacte con el soporte.',
  'admin.login.demo': 'Acceso administrador: izisender@gmail.com — contraseña modificable en los ajustes.',
  'admin.login.backClient': 'Área de cliente',
  'admin.login.show': 'Mostrar la contraseña',
  'admin.login.hide': 'Ocultar la contraseña',
  'admin.login.panelTitle': 'Gestione Monexa con total tranquilidad.',
  'admin.login.panelText': 'Clientes, saldos, solicitudes de retiro y seguridad: todo se gestiona desde una única interfaz registrada.',
  'admin.login.meta1': 'Acceso administrador protegido',
  'admin.login.meta2': 'Cada acción queda registrada',
  'admin.login.meta3': 'Bloqueo de IP y códigos de validación',

  'admin.overview.clients': 'Clientes',
  'admin.overview.activeHint': '{{count}} cuentas activas',
  'admin.overview.withdrawals': 'Solicitudes de retiro',
  'admin.overview.allTime': 'Desde el lanzamiento',
  'admin.overview.pending': 'Pendientes',
  'admin.overview.awaiting': 'Por tramitar',
  'admin.overview.executed': 'Ejecutadas',
  'admin.overview.completed': 'Retiros finalizados',
  'admin.overview.balances': 'Saldos registrados',
  'admin.overview.byCurrency': 'Agrupación por divisa',
  'admin.overview.accounts': '{{count}} cuenta(s)',
  'admin.overview.statuses': 'Estados de las solicitudes',
  'admin.overview.statusesHint': 'Reparto de las solicitudes de retiro',
  'admin.overview.recentRequests': 'Últimas solicitudes',
  'admin.overview.seeAll': 'Ver todo',
  'admin.overview.recent': 'Últimas operaciones',
  'admin.overview.alerts': 'Alertas de seguridad',
  'admin.overview.noAlerts': 'Ninguna alerta activa.',
  'admin.overview.activity': 'Últimas actividades',
  'admin.overview.transfers': 'Transferencias',
  'admin.overview.transfersPending': 'Transferencias pendientes',
  'admin.overview.transfersExecuted': 'Transferencias ejecutadas',
  'admin.overview.recentTransfers': 'Últimas transferencias',
  'admin.overview.disabledLinks': '{{count}} enlace(s) de transferencia desactivado(s)',

  'admin.wd.title': 'Solicitudes de retiro',
  'admin.wd.subtitle': 'Apruebe, rechace o cierre las solicitudes de los clientes.',
  'admin.wd.ref': 'Referencia',
  'admin.wd.client': 'Cliente',
  'admin.wd.beneficiary': 'Beneficiario',
  'admin.wd.bank': 'Banco',
  'admin.wd.amount': 'Importe',
  'admin.wd.status': 'Estado',
  'admin.wd.date': 'Fecha',
  'admin.wd.empty': 'No hay solicitudes por el momento.',
  'admin.wd.review': 'Tramitar',
  'admin.wd.detail': 'Detalle de la solicitud',
  'admin.wd.approve': 'Aprobar',
  'admin.wd.reject': 'Rechazar',
  'admin.wd.execute': 'Marcar ejecutada',
  'admin.wd.note': 'Motivo / nota interna',
  'admin.wd.notePh': 'Indique la razón de su decisión',
  'admin.wd.noteRequired': 'Indique un motivo de rechazo.',
  'admin.wd.updated': 'Estado actualizado.',
  'admin.wd.insufficient': 'Saldo insuficiente para ejecutar este retiro.',
  'admin.wd.alreadyExecuted': 'Esta solicitud ya se ha ejecutado.',
  'admin.wd.iban': 'Datos bancarios',
  'admin.wd.phone': 'Teléfono',
  'admin.wd.email': 'Correo',
  'admin.wd.submitted': 'Enviada el',
  'admin.wd.created': 'Creada el',

  'admin.clients.title': 'Clientes',
  'admin.clients.subtitle': 'Las fichas de cliente se crean automáticamente con cada nueva transferencia.',
  'admin.clients.search': 'Buscar un cliente',
  'admin.clients.new': 'Nuevo cliente',
  'admin.clients.name': 'Nombre completo',
  'admin.clients.email': 'Correo',
  'admin.clients.phone': 'Teléfono',
  'admin.clients.currency': 'Divisa',
  'admin.clients.card': 'Tarjeta de demostración',
  'admin.clients.balance': 'Saldo',
  'admin.clients.status': 'Estado',
  'admin.clients.actions': 'Acciones',
  'admin.clients.active': 'Activo',
  'admin.clients.disabled': 'Desactivado',
  'admin.clients.empty': 'No hay clientes por el momento.',
  'admin.clients.bankLogin': 'Identificador bancario',
  'admin.clients.manage': 'Gestionar',
  'admin.clients.create.title': 'Crear un cliente',
  'admin.clients.create.subtitle': 'Se generarán automáticamente una tarjeta de demostración y las credenciales.',
  'admin.clients.create.amount': 'Importe inicial',
  'admin.clients.create.done': 'Cuenta creada',
  'admin.clients.create.credentials': 'Credenciales generadas',
  'admin.clients.create.accessCode': 'Código de identificación',
  'admin.clients.create.bankLogin': 'Identificador bancario',
  'admin.clients.create.bankPassword': 'Contraseña bancaria',
  'admin.clients.create.warning': 'Comunique estos datos por un canal seguro. No se volverán a mostrar.',
  'admin.clients.create.card': 'Red de la tarjeta de demostración',
  'admin.clients.create.submit': 'Crear la cuenta',
  'admin.clients.create.missing': 'El nombre completo es obligatorio.',
  'admin.clients.create.invalidEmail': 'La dirección de correo no es válida.',
  'admin.clients.detail.title': 'Ficha del cliente',
  'admin.clients.detail.since': 'cliente desde el',
  'admin.clients.detail.card': 'Tarjeta de demostración',
  'admin.clients.detail.adjust': 'Ajustar el saldo',
  'admin.clients.detail.adjustAmount': 'Importe (negativo para cargar)',
  'admin.clients.detail.adjustLabel': 'Concepto de la operación',
  'admin.clients.detail.adjustSubmit': 'Guardar',
  'admin.clients.detail.regen': 'Regenerar el código',
  'admin.clients.detail.disable': 'Desactivar',
  'admin.clients.detail.enable': 'Reactivar',
  'admin.clients.detail.transactions': 'Historial de transacciones',
  'admin.clients.detail.withdrawals': 'Solicitudes de retiro',
  'admin.clients.detail.noTx': 'Sin transacciones.',
  'admin.clients.detail.updated': 'Actualización realizada.',
  'admin.clients.detail.newCode': 'Nuevo código de identificación',
  'admin.clients.detail.invalidAmount': 'Introduzca un importe distinto de cero.',
  'admin.clients.detail.balanceError': 'Ajuste imposible: saldo insuficiente.',
  'admin.clients.detail.transfers': 'Transferencias vinculadas',
  'admin.clients.detail.sendCredentials': 'Enviar las credenciales',
  'admin.clients.detail.credentialsTitle': 'Credenciales generadas',
  'admin.clients.detail.noEmail': 'No hay dirección de correo registrada para este cliente.',
  'admin.clients.detail.deleteTitle': 'Eliminar la ficha del cliente',
  'admin.clients.detail.deleteText': 'Esta acción es definitiva: se eliminarán la ficha, sus credenciales y sus sesiones. La transferencia vinculada seguirá consultable.',
  'admin.clients.detail.deleteConfirm': 'Eliminar definitivamente',

  'admin.codes.title': 'Códigos de validación',
  'admin.codes.subtitle': 'Genere y gestione los códigos de confirmación.',
  'admin.codes.empty': 'Ningún código generado.',
  'admin.codes.code': 'Código',
  'admin.codes.operation': 'Operación',
  'admin.codes.attempts': 'Intentos',
  'admin.codes.expires': 'Caduca el',
  'admin.codes.revoke': 'Invalidar',
  'admin.codes.generate': 'Generar un código',
  'admin.codes.generateHint': 'El código solo es válido una vez.',
  'admin.codes.ref': 'Referencia de la operación',
  'admin.codes.validity': 'Validez (min)',
  'admin.codes.created': 'Código generado',
  'admin.codes.type.withdrawal': 'Retiro',
  'admin.codes.type.settings': 'Parámetros',
  'admin.codes.type.login': 'Conexión sensible',
  'admin.codes.state.active': 'Activo',
  'admin.codes.state.used': 'Usado',
  'admin.codes.state.expired': 'Caducado',

  'admin.banks.title': 'Bancos',
  'admin.banks.subtitle': 'Lista propuesta en el formulario de retiro.',
  'admin.banks.add': 'Añadir un banco',
  'admin.banks.name': 'Nombre del banco',
  'admin.banks.country': 'País',
  'admin.banks.swift': 'Código SWIFT',
  'admin.banks.order': 'Orden',
  'admin.banks.active': 'Banco activo',
  'admin.banks.save': 'Guardar',
  'admin.banks.empty': 'Ningún banco registrado.',
  'admin.banks.saved': 'Banco guardado.',
  'admin.banks.edit': 'Modificar el banco',
  'admin.banks.nameRequired': 'El nombre del banco es obligatorio.',
  'admin.banks.toggle': 'Activar o desactivar',
  'admin.banks.activeLabel': 'Activo',
  'admin.banks.inactiveLabel': 'Inactivo',

  'admin.ip.title': 'Bloqueo de IP',
  'admin.ip.subtitle': 'Vigile los intentos de conexión y bloquee las redes sospechosas.',
  'admin.ip.address': 'Dirección IP',
  'admin.ip.country': 'País estimado',
  'admin.ip.attempts': 'Intentos',
  'admin.ip.failures': 'Fallos',
  'admin.ip.lastSeen': 'Última actividad',
  'admin.ip.block': 'Bloquear',
  'admin.ip.unblock': 'Desbloquear',
  'admin.ip.blocked': 'Bloqueada',
  'admin.ip.blockedTitle': 'Direcciones bloqueadas',
  'admin.ip.blockedHint': 'Los bloqueos se aplican en el servidor.',
  'admin.ip.empty': 'Ninguna dirección bloqueada.',
  'admin.ip.emptyAttempts': 'Ningún intento registrado.',
  'admin.ip.note': 'Geolocalización aproximada',
  'admin.ip.until': 'Hasta el',
  'admin.ip.permanent': 'Bloqueo permanente',
  'admin.ip.blockTitle': 'Bloquear una dirección IP',
  'admin.ip.blockWarning': 'Las sesiones activas de esta dirección se cerrarán de inmediato.',
  'admin.ip.reason': 'Motivo del bloqueo',
  'admin.ip.reasonPh': 'Intentos repetidos, comportamiento sospechoso…',
  'admin.ip.hours': 'Duración (horas)',
  'admin.ip.hoursHint': '0 = bloqueo permanente',
  'admin.ip.blockedDone': 'Dirección IP bloqueada.',
  'admin.ip.unblockedDone': 'Bloqueo levantado.',
  'admin.ip.stateActive': 'Activo',
  'admin.ip.stateLifted': 'Levantado',
  'admin.ip.manualTitle': 'Bloquear manualmente una dirección',
  'admin.ip.manualSubtitle': 'Introduzca una dirección IP para bloquearla de inmediato.',
  'admin.ip.manualDefaultReason': 'Bloqueo manual del administrador',
  'admin.ip.invalidIp': 'Dirección IP no válida.',
  'admin.ip.invalidDuration': 'Duración no válida (0 a 8760 horas).',
  'admin.ip.historyTitle': 'Historial de bloqueos',
  'admin.ip.historyHint': 'Todas las acciones de bloqueo y desbloqueo.',
  'admin.ip.historyEmpty': 'Ningún evento de bloqueo.',
  'admin.ip.historyBlocked': 'Dirección bloqueada',
  'admin.ip.historyUnblocked': 'Bloqueo levantado',

  'admin.logs.title': 'Registros de actividad',
  'admin.logs.subtitle': 'Historial de las acciones sensibles de la plataforma.',
  'admin.logs.date': 'Fecha',
  'admin.logs.actor': 'Autor',
  'admin.logs.action': 'Acción',
  'admin.logs.target': 'Objetivo',
  'admin.logs.ip': 'Dirección IP',
  'admin.logs.empty': 'Ningún evento registrado.',
  'admin.logs.search': 'Filtrar por acción',
  'admin.logs.apply': 'Filtrar',

  'admin.settings.title': 'Ajustes',
  'admin.settings.subtitle': 'Parámetros de la plataforma y de la seguridad.',
  'admin.settings.general': 'General',
  'admin.settings.platformName': 'Nombre de la plataforma',
  'admin.settings.supportEmail': 'Correo del soporte (visible para los clientes)',
  'admin.settings.adminEmail': 'Correo de conexión del administrador',
  'admin.settings.adminEmailHint': 'Se requiere una verificación antes de activarlo.',
  'admin.settings.maxAttempts': 'Intentos de conexión autorizados',
  'admin.settings.generalSaved': 'Ajustes guardados.',
  'admin.settings.security': 'Contraseña del administrador',
  'admin.settings.currentPassword': 'Contraseña actual',
  'admin.settings.newPassword': 'Nueva contraseña',
  'admin.settings.confirmPassword': 'Confirmar la contraseña',
  'admin.settings.changePassword': 'Modificar la contraseña',
  'admin.settings.passwordRules': 'Mínimo 10 caracteres, con mayúscula, minúscula y cifra.',
  'admin.settings.passwordWeak': 'La contraseña no cumple los requisitos.',
  'admin.settings.passwordMismatch': 'Las contraseñas no coinciden.',
  'admin.settings.passwordWrong': 'La contraseña actual es incorrecta.',
  'admin.settings.passwordDone': 'Contraseña modificada.',
  'admin.settings.invalidEmail': 'La dirección de correo no es válida.',
  'admin.settings.notifications': 'Notificaciones de Telegram',
  'admin.settings.telegramEnabled': 'Activar las notificaciones de Telegram',
  'admin.settings.telegramToken': 'Token del bot',
  'admin.settings.telegramChat': 'Identificador del canal',
  'admin.settings.telegramHint': 'Las alertas se envían en cuanto se indican el token y el canal.',
  'admin.settings.siteUrl': 'URL pública del sitio',
  'admin.settings.siteUrlHint': 'Se utiliza en los botones de los correos (ej. https://monexa.app).',
  'admin.settings.senderName': 'Nombre del remitente de los correos',
  'admin.settings.senderNameHint': 'Nombre que aparece en la bandeja de entrada del destinatario.',
  'admin.settings.role': 'Rol de esta cuenta',
  'admin.settings.emailSending': 'Envío de correos',
  'admin.settings.emailSender': 'Dirección de envío',
  'admin.settings.emailReady': 'Dominio activo',
  'admin.settings.emailMissing': 'Dominio no configurado',

  'admin.data.title': 'Gestión y eliminación',
  'admin.data.subtitle': 'Elimine datos de forma definitiva. Acción irreversible.',
  'admin.data.clients': 'Cuentas de clientes',
  'admin.data.withdrawals': 'Solicitudes de retiro',
  'admin.data.transfers': 'Transferencias',
  'admin.data.codes': 'Códigos de validación',
  'admin.data.ips': 'Direcciones IP bloqueadas',
  'admin.data.delete': 'Eliminar',
  'admin.data.confirmTitle': 'Confirmar la eliminación',
  'admin.data.confirmText': 'Esta acción es definitiva. También se eliminarán los datos vinculados y no será posible volver atrás.',
  'admin.data.deleted': 'Eliminación realizada.',
  'admin.data.empty': 'Ningún elemento.',

  'admin.roles.owner': 'Propietario',
  'admin.roles.admin': 'Administrador',
  'admin.roles.support': 'Soporte',

  'admin.emailState.sent': 'Enviado',
  'admin.emailState.failed': 'Fallo',
  'admin.emailState.queued': 'En cola',
  'admin.emailState.not_configured': 'Sin configurar',

  'admin.transfers.statTotal': 'Transferencias',
  'admin.transfers.statPending': 'Pendientes',
  'admin.transfers.statExecuted': 'Ejecutadas',
  'admin.transfers.statMail': 'Correos a verificar',
  'admin.transfers.title': 'Transferencias bancarias',
  'admin.transfers.subtitle': 'Cree una transferencia a un beneficiario y siga su notificación.',
  'admin.transfers.new': 'Nueva transferencia',
  'admin.transfers.newHint': 'El beneficiario recibe de inmediato un correo con un enlace a la autenticación bancaria.',
  'admin.transfers.empty': 'Ninguna transferencia registrada.',
  'admin.transfers.ref': 'Referencia',
  'admin.transfers.beneficiary': 'Beneficiario',
  'admin.transfers.bank': 'Banco del beneficiario',
  'admin.transfers.amount': 'Importe',
  'admin.transfers.status': 'Estado',
  'admin.transfers.emailStatus': 'Notificación',
  'admin.transfers.date': 'Fecha',
  'admin.transfers.open': 'Abrir',
  'admin.transfers.submit': 'Crear la transferencia',
  'admin.transfers.missing': 'Complete todos los campos obligatorios.',
  'admin.transfers.invalidEmail': 'La dirección de correo no es válida.',
  'admin.transfers.invalidIban': 'El IBAN parece incorrecto (mínimo 8 caracteres).',
  'admin.transfers.invalidAmount': 'El importe debe ser superior a cero.',
  'admin.transfers.amountTooHigh': 'El importe supera el límite permitido ({{max}}).',
  'admin.transfers.amountHint': 'Límite: {{max}}.',
  'admin.transfers.invalidBank': 'Seleccione un banco beneficiario activo.',
  'admin.transfers.createdSent': 'Transferencia {{reference}} creada, notificación enviada al beneficiario.',
  'admin.transfers.createdNoMail': 'Transferencia {{reference}} creada, pero no se ha podido enviar la notificación. Compruebe la configuración de correo.',
  'admin.transfers.alreadyExecuted': 'Esta transferencia ya se ha ejecutado.',
  'admin.transfers.resent': 'Notificación reenviada.',
  'admin.transfers.resendFailed': 'Reenvío imposible: la configuración de correo está incompleta.',
  'admin.transfers.updated': 'Transferencia actualizada.',
  'admin.transfers.detail': 'Detalle de la transferencia',
  'admin.transfers.resend': 'Reenviar el correo',
  'admin.transfers.cancel': 'Anular la transferencia',
  'admin.transfers.execute': 'Marcar ejecutada',
  'admin.transfers.by': 'Creada por',
  'admin.transfers.note': 'Nota interna',
  'admin.transfers.notePh': 'Referencia externa, instrucción…',
  'admin.transfers.firstName': 'Nombre del beneficiario',
  'admin.transfers.lastName': 'Apellidos del beneficiario',
  'admin.transfers.email': 'Correo del beneficiario',
  'admin.transfers.iban': 'IBAN del beneficiario',
  'admin.transfers.currency': 'Divisa',
  'admin.transfers.lang': 'Idioma del beneficiario',
  'admin.transfers.bankPh': 'Seleccione un banco',
  'admin.transfers.mailInfo': 'Al validar, el beneficiario recibe un correo con el importe y un botón «Activar mi transferencia».',
  'admin.transfers.emailError': 'Error de envío',
  'admin.transfers.activation': 'Autenticación bancaria',
  'admin.transfers.activationLink': 'Enlace de activación del beneficiario',
  'admin.transfers.activationHint': 'Este enlace abre la página de autenticación bancaria del banco seleccionado.',
  'admin.transfers.copyLink': 'Copiar el enlace',
  'admin.transfers.openLink': 'Abrir la página',
  'admin.transfers.linkCopied': 'Enlace de activación copiado.',
  'admin.transfers.verifiedAt': 'Autenticado el',
  'admin.transfers.awaitingAuth': 'Pendiente de autenticación bancaria',
  'admin.transfers.notVerified': 'El beneficiario debe autenticarse primero ante su banco para que la transferencia pueda ejecutarse.',
  'admin.transfers.resendHint': 'Se genera un nuevo enlace, se reinician los intentos y se reenvía el correo.',
  'admin.transfers.statVerified': 'Autenticados',
  'admin.transfers.authAttempts': 'Intentos incorrectos',
  'admin.transfers.filterVerified': 'Autenticados',
  'admin.transfers.linkColumn': 'Enlace',
  'admin.transfers.linkActive': 'Activo',
  'admin.transfers.linkDisabled': 'Desactivado',
  'admin.transfers.linkDisable': 'Desactivar el enlace',
  'admin.transfers.linkEnable': 'Reactivar el enlace',
  'admin.transfers.linkDisabledAt': 'Enlace desactivado el {{date}}.',
  'admin.transfers.linkDisabledHint': 'Este enlace está desactivado: la página no es accesible.',
  'admin.transfers.linkEnabled': 'Enlace reactivado.',
  'admin.transfers.linkDisableDone': 'Enlace desactivado.',
  'admin.transfers.pdfOpen': 'Vista previa PDF',
  'admin.transfers.pdfDownload': 'Descargar el PDF',
  'admin.transfers.clientRecord': 'Ficha de cliente asociada',
  'admin.transfers.clientLogin': 'Identificador',
  'admin.transfers.clientLinked': 'Ficha creada',
  'admin.transfers.clientCreated': 'Ficha de cliente, tarjeta y credenciales generadas automáticamente (identificador: {{login}}).',
  'admin.transfers.noClient': 'Ninguna ficha de cliente asociada a esta transferencia.',
  'admin.transfers.sendCredentials': 'Enviar las credenciales',
  'admin.transfers.credentialsSent': 'Credenciales enviadas al beneficiario.',
  'admin.transfers.credentialsNotSent': 'Credenciales generadas pero correo no entregado.',
  'admin.transfers.statLinks': 'Enlaces desactivados',

  'admin.mail.compose': 'Nuevo mensaje',
  'admin.mail.composeHint': 'Redacte un correo personalizado a un cliente.',
  'admin.mail.recipient': 'Destinatario (cliente)',
  'admin.mail.recipientPh': 'Seleccione un cliente',
  'admin.mail.recipientManual': 'O introducir una dirección de correo',
  'admin.mail.templates': 'Plantillas predefinidas',
  'admin.mail.tpl.welcome': 'Bienvenida',
  'admin.mail.tpl.transfer_info': 'Transferencia recibida',
  'admin.mail.tpl.security': 'Alerta de seguridad',
  'admin.mail.tpl.withdrawal': 'Seguimiento del retiro',
  'admin.mail.tpl.reminder': 'Recordatorio de activación',
  'admin.mail.subject': 'Asunto',
  'admin.mail.subjectPh': 'Asunto del correo',
  'admin.mail.message': 'Mensaje',
  'admin.mail.messagePh': 'Redacte su mensaje…',
  'admin.mail.preview': 'Previsualizar',
  'admin.mail.send': 'Enviar el correo',
  'admin.mail.sent': 'Correo enviado.',
  'admin.mail.notSent': 'Correo no enviado: la configuración de envío está incompleta.',
  'admin.mail.missing': 'Destinatario, asunto y mensaje son obligatorios.',
  'admin.mail.invalidEmail': 'La dirección de correo no es válida.',
  'admin.mail.deliveryInfo': 'Los envíos requieren una clave y un dominio de envío configurados en el panel Resend. Sin ellos, el correo se registra pero no se entrega.',
  'admin.mail.history': 'Historial de correos',
  'admin.mail.historyHint': 'Todos los mensajes transmitidos y su estado.',
  'admin.mail.empty': 'Ningún correo enviado.',

  'admin.cred.title': 'Credenciales y accesos',
  'admin.cred.subtitle': 'Genere nuevas credenciales y envíelas al cliente por correo.',
  'admin.cred.client': 'Cliente',
  'admin.cred.clientPh': 'Seleccione un cliente',
  'admin.cred.email': 'Dirección de envío',
  'admin.cred.emailHint': 'Las credenciales se enviarán a esta dirección.',
  'admin.cred.current': 'Cuenta seleccionada',
  'admin.cred.warning': 'La generación invalida las credenciales actuales y desconecta al cliente de todas sus sesiones.',
  'admin.cred.generate': 'Generar y enviar las credenciales',
  'admin.cred.done': 'Credenciales generadas',
  'admin.cred.mailSent': 'Credenciales enviadas a {{email}}.',
  'admin.cred.mailNotSent': 'Credenciales generadas, pero el correo no se ha podido entregar. Comuníquelas manualmente.',
  'admin.cred.history': 'Historial de envíos',
  'admin.cred.historyHint': 'Cada generación queda registrada.',
  'admin.cred.empty': 'Ningún envío de credenciales.',

  'admin.authState.created': 'Enlace enviado',
  'admin.authState.authenticated': 'Autenticado',
  'admin.authState.locked': 'Bloqueado',
  'admin.authState.closed': 'Cerrado',

  'flow.eyebrow': 'Transferencia bancaria recibida',
  'flow.title': 'Le corresponde una transferencia',
  'flow.subtitle': 'Compruebe la operación y autentíquese ante su banco para confirmar la recepción.',
  'flow.amount': 'Importe recibido',
  'flow.beneficiary': 'Beneficiario',
  'flow.bank': 'Banco del beneficiario',
  'flow.reference': 'Referencia',
  'flow.date': 'Fecha de la operación',
  'flow.bankPanelTitle': 'Entidad concernida',
  'flow.secure1': 'Conexión cifrada de extremo a extremo',
  'flow.secure2': 'Verificación ante el banco emisor',
  'flow.secure3': 'Cada etapa queda registrada',
  'flow.footnote': 'No comunique nunca sus credenciales por teléfono ni por correo.',
  'flow.bankTitle': 'Autenticación bancaria',
  'flow.bankText': 'Identifíquese en el servicio en línea de {{bank}} para autorizar la recepción de esta transferencia.',
  'flow.login': 'Identificador bancario',
  'flow.loginPh': 'Su identificador bancario',
  'flow.password': 'Contraseña bancaria',
  'flow.passwordPh': 'Su contraseña',
  'flow.authSubmit': 'Autorizar la recepción',
  'flow.authSubmitting': 'Conexión segura…',
  'flow.attempts': '{{left}} intento(s) restante(s)',
  'flow.secure': 'Credenciales nunca almacenadas',
  'flow.errorCredentials': 'Credenciales rechazadas por el banco. Le quedan {{left}} intento(s).',
  'flow.errorRequired': 'Indique sus credenciales bancarias.',
  'flow.successTitle': 'Autenticación confirmada',
  'flow.successText': 'Su identidad bancaria ha sido verificada. La transferencia está validada y será tramitada por el emisor.',
  'flow.successPending': 'No debe realizar ninguna acción adicional. Puede cerrar esta página.',
  'flow.verifiedAt': 'Verificado el',
  'flow.lockedTitle': 'Enlace de activación bloqueado',
  'flow.lockedText': 'Demasiados intentos incorrectos. Por su seguridad, esta operación queda suspendida. Contacte con el emisor de la transferencia para obtener un nuevo enlace.',
  'flow.expiredTitle': 'Enlace caducado',
  'flow.expiredText': 'Este enlace de activación ya no es válido. Contacte con el emisor de la transferencia para obtener uno nuevo.',
  'flow.cancelledTitle': 'Operación anulada',
  'flow.cancelledText': 'Esta operación ha sido anulada por el emisor de la transferencia.',
  'flow.executedTitle': 'Transferencia ya ejecutada',
  'flow.executedText': 'Esta transferencia ya se ha ejecutado. No debe realizar ninguna acción adicional.',
  'flow.linkDisabledTitle': 'Enlace desactivado',
  'flow.linkDisabledText': 'El emisor de la transferencia ha desactivado este enlace. Contacte con él para obtener nuevas instrucciones.',
  'flow.blockedTitle': 'Acceso bloqueado',
  'flow.blockedText': 'El acceso desde su red se ha bloqueado por motivos de seguridad. Contacte con el emisor de la transferencia.',
  'flow.notFoundTitle': 'Operación no encontrada',
  'flow.notFoundText': 'Este enlace está incompleto o ya no existe. Compruebe el correo recibido o contacte con el soporte.',
  'flow.statusLabel': 'Estado de la operación',

  'status.draft': 'Borrador',
  'status.pending': 'Pendiente',
  'status.verified': 'Por ejecutar',
  'status.approved': 'Aprobada',
  'status.rejected': 'Rechazada',
  'status.executed': 'Ejecutada',
  'status.cancelled': 'Anulada',
  'status.auth_failed': 'Autenticación fallida',
};